import { Box, Button,  Grid, Heading, Image, Text } from '@chakra-ui/react'
import React, { useContext } from 'react'
import logo from "../images/asim-pic.jpg"
import { keyframes } from '@emotion/react';
import { ThemeContext } from './context/ThemeProvider';
import resume from "../images/Mohd-Asim-Resume.pdf"

const blinkAnimation = keyframes`
  0% {
    opacity: 0;
  }
  50% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
`;

const Home = () => {
  const handleResumeClick = () => {
    window.open("https://drive.google.com/file/d/1Lz28EkrucbnQa5akIdNdX4ZRdzGarM7m/view?usp=sharing",'_blank');
  };
  const {theme}=useContext(ThemeContext)
  return (
    <Box style={theme?{color:'black'}:{color:'white'}} id='home'  p={{xl:'0 0 0 5vh'}} >
         <Grid templateColumns={{xl:'repeat(2,1fr)',base:'repeat(1,1fr)'}}   >
        <Box className='main1' p={{xl:'13vh',base:'5vh'}}  >
            <Box textAlign={'left'}  mt={{xl:'10vh'}} >

            <Text >WELCOME TO MY WORLD</Text>
        <Heading  id="user-detail-name" mt={{xl:4,base:2}}>Hi, I'm  <span style={{color:'#ff014f'}} id="user-detail-name">  MOHD ASIM </span></Heading>
    
        <Heading 
          as="span"
          display="inline-block"
          animation={`${blinkAnimation} 3s infinite`}
          
        >
        A Full Stack Web Developer.</Heading>
            </Box>
      <Box textAlign={'left'} > 

      <a href={resume} download={'Mohd-Asim-Resume.pdf'}>

<Button mt={{xl:'5vh',base:'3vh'}} onClick={handleResumeClick} bg={'rgb(0, 255, 162)'}  id="resume-button-2" 
style={theme?{color:'black'}:{color:'black'}}
>RESUME</Button>
</a>
  
            </Box> 

        </Box>
        
    
    <Box  className='main2'  display={'flex'} alignItems={'center'} justifyContent={'center'}
    h='50%' mt={{xl:'18vh',lg:'5vh',base:'3vh'}}
     >
        <Image src={logo} w={{xl:"60%",base:'50%'}}  boxShadow='dark-lg' borderRadius={'50%'}  className="home-img"
        />
     </Box>

    </Grid>

      
    </Box>
  )
}

export default Home
